import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a633774"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}

import GanttChartComponent from '@/components/GanttChartComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'GanttChartView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GanttChartComponent)
  ]))
}
}

})